// components/GlobalLoaderRoot.js

import React, { useState, useEffect } from 'react';
import { registerLoadingCallback } from './axiosInstance';

const GlobalLoaderRoot = () => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    // Register this component's state setter globally with Axios
    registerLoadingCallback(setIsLoading);

    // Optional: Cleanup the callback when this component unmounts
    return () => {
      registerLoadingCallback(() => {}); 
    };
  }, []);

  if (!isLoading) return null;

  return (
     <div className="global-loader-overlay">
      
      {/* <div className="loader-spinner"></div>  */}
       <img src='/images/loadinggif.gif' /> 
    </div>
  );
};

export default GlobalLoaderRoot;
